module.exports = __webpack_public_path__ + "static/media/popcornparrot.3190c1cd.gif";